import React from 'react';
import { Pressable, View, HStack, Flex, Text, Box, Avatar, useTheme } from 'native-base';
import { CHANNEL_PHOTO_SIZE } from '../../Constants';
import { useCategoriesDispatch } from '../../../context/categories';
const Channel = ({
  selectedCategory,
  setSelectedCategory,
  item,
  channelImage,
  orientation,
  setPage,
  setHasMoreTopics
}) => {
  const theme = useTheme(),
    {
      colors
    } = theme;
  const categoriesDispatch = useCategoriesDispatch();
  const handleOnPress = () => {
    if (item) {
      if (item.id > 0) {
        setSelectedCategory(item);
        categoriesDispatch({
          type: 'SET_SELECTED_CATEGORY',
          payload: item
        });

        // reset page number on channel selection change for proper topics pagination
        setPage(0);
        setHasMoreTopics(true);
      } else {
        setSelectedCategory(null);
        setPage(0);
        setHasMoreTopics(true);
      }
    }
    window.scrollTo(0, 0);
  };
  const isSelected = selectedCategory ? item.id === selectedCategory.id : item.id < 0;
  const OverviewChannel = () => {
    return /*#__PURE__*/React.createElement(Box, {
      borderColor: colors.menu.channel.box.border,
      bg: isSelected ? colors.menu.channel.box.bg.selected : colors.menu.channel.box.bg.default,
      borderWidth: isSelected ? '2' : '1',
      rounded: 'lg',
      mx: 2,
      justifyContent: 'center',
      alignItems: 'center'
    }, /*#__PURE__*/React.createElement(Pressable, {
      onPress: handleOnPress,
      p: 1
    }, /*#__PURE__*/React.createElement(Flex, {
      direction: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      pr: 2
    }, /*#__PURE__*/React.createElement(Avatar, {
      source: {
        uri: channelImage
      },
      size: CHANNEL_PHOTO_SIZE,
      borderRadius: 8
    }, "Channel Image"), /*#__PURE__*/React.createElement(Text, {
      ml: 3,
      color: isSelected ? colors.menu.channel.selected.name : colors.menu.channel.default.name,
      bold: isSelected
    }, item.name))));
  };
  const SideMenuChannel = () => {
    return /*#__PURE__*/React.createElement(Pressable, {
      onPress: handleOnPress
    }, /*#__PURE__*/React.createElement(View, {
      borderColor: isSelected ? colors.menu.channel.selected.border : colors.menu.channel.default.border,
      bg: isSelected ? colors.menu.channel.selected.bg : colors.menu.channel.default.bg,
      borderWidth: 2,
      rounded: 'lg',
      justifyContent: 'center',
      alignItems: 'center',
      p: 2
    }, /*#__PURE__*/React.createElement(HStack, {
      justifyContent: 'left',
      alignItems: 'center',
      w: '100%'
    }, /*#__PURE__*/React.createElement(Avatar, {
      source: {
        uri: channelImage
      },
      size: CHANNEL_PHOTO_SIZE,
      borderRadius: 8
    }, "Channel Image"), /*#__PURE__*/React.createElement(Text, {
      ml: 3,
      color: isSelected ? colors.menu.channel.selected.name : colors.menu.channel.default.name,
      bold: isSelected
    }, item.name))));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, orientation === 'horizontal' && /*#__PURE__*/React.createElement(OverviewChannel, null), orientation === 'vertical' && /*#__PURE__*/React.createElement(SideMenuChannel, null));
};
export default Channel;
//# sourceMappingURL=Channel.js.map